var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1877 15L19.1867 12.8102L17 12.8112V11.1877H19.1867L19.1877 9H20.8102V11.1877H23V12.8112L20.8102 12.8102V15H19.1877Z",
    fill: "#0084F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00004 6.18883C6.00893 7.79139 7.31446 9.08446 8.91613 9.07646C10.5196 9.06757 11.8118 7.76293 11.8038 6.16037C11.7966 4.55692 10.4902 3.26474 8.88767 3.27274C7.28511 3.27986 5.99203 4.58627 6.00004 6.18883Z",
    stroke: "#0084F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.931C14.9827 15.0847 12.0581 11.9807 8.46823 12.0001C4.87839 12.0194 1.9828 15.1537 2.00008 19L15 18.931Z",
    stroke: "#0084F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Active.afccac27.svg";
export { ForwardRef as ReactComponent };